module.exports = __webpack_public_path__ + "img/candidatedis.2541e13d.svg";